module.exports = __webpack_public_path__ + "img/img_19.5e24ede5.png";